import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

// Utility function for common transport data preparation
const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Transport Vehicle Services
export const getVehicleList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getVehicle = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addVehicle = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateVehicle = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteVehicle = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateVehicleStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/vehicle",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};
